import React from 'react';
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';
import Select from '../Select';
import ConfigConsumer from '../ConfigConsumer';
import QuickJumper from './component/QuickJumper';
import SimplePagination from './component/SimplePagination';
import NormalPagination from './component/NormalPagination';
import { getCurrentPage, getShowData, operateConfig } from './utils/index';
import { getLocale } from '../locale';

var Pagination = function Pagination(_ref) {
  var id = _ref.id,
      className = _ref.className,
      hideOnSinglePage = _ref.hideOnSinglePage,
      simple = _ref.simple,
      size = _ref.size,
      showSizeChanger = _ref.showSizeChanger,
      showQuickJumper = _ref.showQuickJumper,
      pageSize = _ref.pageSize,
      segmentNum = _ref.segmentNum,
      total = _ref.total,
      current = _ref.current,
      onChange = _ref.onChange,
      pageSizeOptions = _ref.pageSizeOptions,
      showTotal = _ref.showTotal,
      border = _ref.border,
      showSegment = _ref.showSegment;
  return /*#__PURE__*/React.createElement(ConfigConsumer, {
    size: size
  }, function (_ref2) {
    var _ref2$size = _ref2.size,
        configSize = _ref2$size === void 0 ? 'middle' : _ref2$size,
        locale = _ref2.locale;
    // 每页数据条数
    var truePageSize = Number(pageSize) > 0 ? Number(pageSize) : 10; // 页码总数

    var totalPage = Math.ceil((total || 1) / truePageSize); // pageSizeChanger list 配置

    pageSizeOptions = pageSizeOptions.map(Number);
    if (!pageSizeOptions.some(function (s) {
      return s === truePageSize;
    })) pageSizeOptions.push(truePageSize);
    pageSizeOptions.sort(function (val1, val2) {
      return val1 - val2;
    });
    var pageSizeList = showSizeChanger ? pageSizeOptions.map(function (length) {
      return {
        label: getLocale(locale).pagination.sizeOptionLabel(length),
        value: length
      };
    }) : [];
    var pageList = getShowData({
      current: current,
      totalPage: totalPage,
      segmentNum: segmentNum,
      showSegment: showSegment,
      size: size
    });
    var operateDisabled = {
      prevDisabled: current === 1,
      nextDisabled: current === totalPage
    };
    var totalContent = showTotal(total, [(current - 1) * truePageSize + 1, current * truePageSize]); // 切换页码

    var onCurrentPage = function onCurrentPage(num, type) {
      if (type === 'number') {
        current !== num && onChange({
          current: num,
          pageSize: pageSize
        });
        return;
      }

      var willPage = current + operateConfig(segmentNum)[type];
      if (willPage > totalPage) willPage = totalPage;
      if (willPage < 1) willPage = 1;
      onChange({
        current: willPage,
        pageSize: pageSize
      });
    }; // 跳转页


    var onJumpChange = function onJumpChange(inpContent) {
      var currentPage = getCurrentPage(total, pageSize, inpContent);

      if (currentPage) {
        onChange({
          current: currentPage,
          pageSize: pageSize
        });
      }
    }; // 切换每页显示数据个数


    var onPageSizeChange = function onPageSizeChange(value) {
      onChange({
        current: getCurrentPage(total, value, current),
        pageSize: value
      });
    }; // 只有一页时，隐藏分页


    if (totalPage === 1 && hideOnSinglePage) return ''; // 简单分页

    if (simple) {
      return /*#__PURE__*/React.createElement(SimplePagination, {
        className: className,
        size: configSize,
        totalPage: totalPage,
        currentPage: current,
        operateDisabled: operateDisabled,
        onCurrentPage: onCurrentPage
      });
    }

    return /*#__PURE__*/React.createElement("div", {
      id: id,
      "data-component-name": "Pagination",
      className: classNames('jmtd-pagination', className, {
        'jmtd-pagination-mini': configSize === 'mini',
        'jmtd-pagination-small': configSize === 'small',
        'jmtd-pagination-middle': ['mini', 'small', 'large'].indexOf(configSize) === -1,
        'jmtd-pagination-large': configSize === 'large'
      })
    }, !!totalContent && /*#__PURE__*/React.createElement("div", {
      className: "jmtd-pagination-total"
    }, totalContent), /*#__PURE__*/React.createElement(NormalPagination, {
      border: border,
      current: current,
      operateDisabled: operateDisabled,
      pageList: pageList,
      onCurrentPage: onCurrentPage
    }), showSizeChanger && /*#__PURE__*/React.createElement(Select, {
      className: "jmtd-pagination-changer",
      width: "auto",
      size: configSize,
      data: pageSizeList,
      value: pageSize,
      onChange: onPageSizeChange
    }), showQuickJumper && /*#__PURE__*/React.createElement(QuickJumper, {
      size: configSize,
      max: totalPage,
      onChange: onJumpChange
    }));
  });
};

Pagination.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.oneOf(['mini', 'small', 'middle', 'large']),
  simple: PropTypes.bool,
  total: PropTypes.number,
  current: PropTypes.number,
  pageSize: PropTypes.number,
  showSizeChanger: PropTypes.bool,
  pageSizeOptions: PropTypes.array,
  showSegment: PropTypes.bool,
  segmentNum: PropTypes.number,
  showQuickJumper: PropTypes.bool,
  border: PropTypes.bool,
  hideOnSinglePage: PropTypes.bool,
  showTotal: PropTypes.func,
  onChange: PropTypes.func
};
Pagination.defaultProps = {
  id: null,
  className: '',
  size: null,
  simple: false,
  border: true,
  total: 1,
  current: 1,
  pageSize: 10,
  showSizeChanger: false,
  pageSizeOptions: [10, 20, 50, 100],
  showSegment: true,
  segmentNum: 5,
  showQuickJumper: false,
  hideOnSinglePage: false,
  showTotal: function showTotal() {},
  // params: total range
  onChange: function onChange() {} // params: page size

};
export default Pagination;